import './src/theme/theme.css';
import { AppRegistry } from 'react-native';
import App from './App.web';

AppRegistry.registerComponent('SK_TICKETS', () => App);
AppRegistry.runApplication('SK_TICKETS', {
  rootTag: document.getElementById('root'),
});
